export default "__VITE_ASSET__CImeaVXy__"